import { LOADING_MESSAGE, LoadingIndicator } from '@fupa/fupa-uikit';
import React from 'react';
import { MessageWrapper } from 'app/components/district/commonStyles';
export default function InfiniteScrollLoadingIndicator(_ref) {
  let {
    message
  } = _ref;
  return /*#__PURE__*/React.createElement(MessageWrapper, {
    "data-sentry-element": "MessageWrapper",
    "data-sentry-component": "InfiniteScrollLoadingIndicator",
    "data-sentry-source-file": "InfiniteScrollLoadingIndicator.tsx"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    message: message !== null && message !== void 0 ? message : LOADING_MESSAGE.loadingStream,
    bgColor: true,
    "data-sentry-element": "LoadingIndicator",
    "data-sentry-source-file": "InfiniteScrollLoadingIndicator.tsx"
  }));
}